import React, { Fragment } from 'react';
import '../loggedOut.css';

const Crafternoon = () => {
    return (
    <Fragment>
        <div className="logged-out">
            <section className="service-hero scene scene--hero page-hero">
                <div className="container">
                    <div className="hero-grid">
                        <div className="hero-copy">
                            <h1 className="display-5 mb-4">Crafternoon</h1>
                            <p className="lead">
                                Located at the Beyond Community Access Hub, our 'Crafternoon' program provides an inclusive and supportive space for participants of all abilities to come together and explore their creativity.
                            </p>
                        </div>
                        <div className="hero-media">
                            <div className="image-shell image-shell--hero">
                                <img
                                    src="/marketing_images/crafternoons/1.jpg"
                                    alt="Group crafting at the Beyond Community Access Hub"
                                    className="img-fluid"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="service-mosaic scene scene--paper story-band">
                <div className="container">
                    <div className="story-card">
                        <div className="row g-4 align-items-center">
                            <div className="col-md-5">
                                <div className="image-shell image-shell--card">
                                    <img
                                        src="/marketing_images/crafternoons/2.jpg"
                                        alt="Group crafting at the Beyond Community Access Hub"
                                        className="img-fluid"
                                    />
                                </div>
                            </div>

                            <div className="col-md-7">
                                <p className="mb-0">
                                    This program is designed to build confidence, encourage skill development, and make crafting accessible to everyone. Participants are supported to learn and create at their own pace, with all the equipment, materials, and guidance they need.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="service-variety scene scene--soft py-6">
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-md-6 order-2 order-md-1">
                            <p>
                                From sewing, quilting, and knitting, to pottery, jewellery making, and floristry, there's something for every interest and ability. Participants can also explore woodwork, painting, paper mache, and other creative projects using recycled materials. For participants looking for a touch of nature, we also offer a natural scavenger hunt where participants can walk the local parks and find natural items like flowers or beautiful leaves to bring back to the Hub and use in their crafting.
                            </p>
                        </div>

                        <div className="col-md-6 order-1 order-md-2">
                            <div className="tile-grid">
                                <div className="tile-card">
                                    <div className="image-shell image-shell--card">
                                        <img
                                            src="/marketing_images/crafternoons/3.jpg"
                                            alt="Textile crafting activities"
                                            className="img-fluid"
                                        />
                                    </div>
                                </div>
                                <div className="tile-card">
                                    <div className="image-shell image-shell--card">
                                        <img
                                            src="/marketing_images/crafternoons/4.jpg"
                                            alt="Hands-on creative crafting"
                                            className="img-fluid"
                                        />
                                    </div>
                                </div>
                                <div className="tile-card">
                                    <div className="image-shell image-shell--card">
                                        <img
                                            src="/marketing_images/crafternoons/5.jpg"
                                            alt="Nature-inspired crafting activities"
                                            className="img-fluid"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="service-invitation scene scene--paper py-6">
                <div className="container text-center">
                    <p className="fs-5 mx-auto mb-4" style={{ maxWidth: "900px" }}>
                        Join us for a fun, social, and inclusive afternoon where everyone is welcome to try new skills, make connections, and enjoy creating in a supportive environment.
                    </p>

                    <div className="image-shell image-shell--wide">
                        <img
                            src="/marketing_images/crafternoons/6.jpg"
                            alt="Completed craft projects at Crafternoon"
                            className="img-fluid"
                        />
                    </div>
                </div>
            </section>
        </div>
    </Fragment>
);

}

export default Crafternoon;
